import { render } from "./BaseFieldInTable.vue?vue&type=template&id=69fe7655"
import script from "./BaseFieldInTable.vue?vue&type=script&lang=js"
export * from "./BaseFieldInTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__